

export default (state = [], action) => {
  if (action.type == "SET_YOMKIPPOUR") {
    return action.value;
  }
  return state;
};